import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";

import PublicSite from "@/pages/PublicSite";
import BlogIndex from "@/pages/BlogIndex";
import BlogPost from "@/pages/BlogPost";
import AdminLogin from "@/pages/AdminLogin";
import AdminLayout from "@/pages/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import HeroManager from "@/pages/admin/HeroManager";
import AboutManager from "@/pages/admin/AboutManager";
import LocationManager from "@/pages/admin/LocationManager";
import AmenitiesManager from "@/pages/admin/AmenitiesManager";
import GalleryManager from "@/pages/admin/GalleryManager";
import PricingManager from "@/pages/admin/PricingManager";
import TestimonialsManager from "@/pages/admin/TestimonialsManager";
import BlogManager from "@/pages/admin/BlogManager";
import BookingsManager from "@/pages/admin/BookingsManager";
import SettingsManager from "@/pages/admin/SettingsManager";
import IntegrationsManager from "@/pages/admin/IntegrationsManager";

function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-earth-50">
        <div className="text-earth-700 font-light tracking-wide">Loading…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<PublicSite />} />
            <Route path="/blog" element={<BlogIndex />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="hero" element={<HeroManager />} />
              <Route path="about" element={<AboutManager />} />
              <Route path="location" element={<LocationManager />} />
              <Route path="amenities" element={<AmenitiesManager />} />
              <Route path="gallery" element={<GalleryManager />} />
              <Route path="pricing" element={<PricingManager />} />
              <Route path="testimonials" element={<TestimonialsManager />} />
              <Route path="blog" element={<BlogManager />} />
              <Route path="bookings" element={<BookingsManager />} />
              <Route path="integrations" element={<IntegrationsManager />} />
              <Route path="settings" element={<SettingsManager />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}
